import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import router from './plugins/router'
import vuetify from './plugins/vuetify'
import store from './store/index'

Vue.config.productionTip = false

Vue.use(VueRouter)

new Vue({
  vuetify,
  render: h => h(App),
  router,
  store
}).$mount('#app')
